/**
 * Lyria 3 —— capability 元数据（与行为字段分离，便于总览页 import.meta.glob 拿展示信息）。
 */
export default {
  id: 'lyria-3',
  nodeType: 'sound',
  label: 'Lyria 3',
  description: 'Google Lyria 3 文生音乐, 自然语言描述生成完整曲目 (30 秒片段 / 最长 3 分钟).',
}
